/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

import "@common/utils/storeInjection";

// Needed for redux-saga es6 generator support
// import "@babel/polyfill";
// import "reflect-metadata";
import "./App.scss";

// Import all the third party stuff
import React, { lazy } from "react";

import { Provider } from "react-redux";
// Import root app

// Load the favicon and the .htaccess file
// import '!file-loader?name=[name].[ext]!./images/favicon.ico';
// import "!file-loader?name=[name].[ext]!./firebase-messaging-sw.js";
// import "file-loader?name=.htaccess!./.htaccess";
import LazyLoad from "@common/components/LazyLoad";
import store from "@store/index";
import setupAnalytics from "@analytics/config";
// import { PersistGate } from "redux-persist/integration/react";
// import { persistor } from "@store/store";
import { createRoot } from "react-dom/client";

const RootContainer = lazy(() => import("@containers/Root/RootContainer"));
setupAnalytics();

const MOUNT_NODE = document.getElementById("app");
localStorage.removeItem("persist:auth");
localStorage.removeItem("persist:profile");
const render = () => {
  const root = createRoot(MOUNT_NODE);

  root.render(
    <Provider store={store}>
      <LazyLoad isFullPage>
        <RootContainer />
      </LazyLoad>
    </Provider>
  );
};

render();

// Install ServiceWorker and AppCache in the end since
// it's not most important operation and if main code fails,
// we do not want it installed

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    // navigator.serviceWorker
    //   .register("/service-worker.js")
    //   .then((registration) => {
    //     console.log("SW registered: ", registration);
    //   })
    //   .catch((registrationError) => {
    //     console.log("SW registration failed: ", registrationError);
    //   });
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();

      if (caches) {
        // Service worker cache should be cleared with caches.delete()
        caches.keys().then(async (names) => {
          await Promise.all(names.map((name) => caches.delete(name)));
        });
      }
    });
  });
}
